<template>

    <div class="dd-m-filter__col">
        <button v-on:click="openSort()" type="button" class="dd-m-filter__btns dd-m-filter__btns--sort">
            <i class="dd-m-icon icon-sort"></i>
            <span class="dd-m-filter__btns__text" v-if="!name">{{getTranslateString('Order by')}}</span>
            <span class="dd-m-filter__btns__text" v-if="name">{{name}}</span>
        </button>

        <card-sort></card-sort>
    </div>

</template>
<script>
    import CardSort from "../cards/card-sort";

    export default {
        name: 'sort-filter',
        components: {CardSort},
        data: () => {
            return {
                name: null
            }
        },
        mounted() {
            this.subscribe();
        },
        methods: {
            openSort: () => {
                PubSub.publish('toggleSortMenu');
            },
            subscribe() {
                PubSub.subscribe('updateSortTitle', (msg, param) => this.name = param);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/filters/sort-filter.vue